import {
  MEDIA_TYPE_VIDEO,
} from './const'

const productHasValidVideo = mediaType => mediaType === MEDIA_TYPE_VIDEO

export default productHasValidVideo
